module.exports = __webpack_public_path__ + "img/phones1.5e00fd9.jpg";